import { render, staticRenderFns } from "./GolfParkImages.vue?vue&type=template&id=2ca7afe9&scoped=true"
import script from "./GolfParkImages.vue?vue&type=script&lang=js"
export * from "./GolfParkImages.vue?vue&type=script&lang=js"
import style0 from "./GolfParkImages.vue?vue&type=style&index=0&id=2ca7afe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca7afe9",
  null
  
)

export default component.exports